import { savedOrderDetailsActionButtonsStyles } from "@insite/content-library/Widgets/SavedOrderDetails/SavedOrderDetailsActionButtons";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import { css } from "styled-components";

savedOrderDetailsActionButtonsStyles.printButton = {
    variant: "secondary",
    // buttonType: "solid",
    // css: css`
    //     border-radius: 0;
    //     padding: 10px 34px;
    //     background: ${getColor("primary")};
    //     border: 2px solid ${getColor("primary")};
    //     span[class^="TypographyStyle"] {
    //         color: ${getColor("common.background")};
    //         font-size: 14px;
    //         line-height: ${TYPOGRAPHY.lineHeight.base};
    //     }
    //     &:hover {
    //         background: ${getColor("text.accent")};
    //         border: 2px solid ${getColor("text.accent")};
    //         span[class^="TypographyStyle"] {
    //             color:${getColor("common.background")};
    //         }
    //     }
    //     ${({ theme }: { theme: BaseTheme }) =>
    //         breakpointMediaQueries(theme, [
    //             null,
    //             null,
    //             css`
    //                 padding: 5px 30px;
    //             `,
    //             null,
    //             null,
    //         ])}
    // `,
};
savedOrderDetailsActionButtonsStyles.deleteButton = {
    variant: "secondary",
    css: css`
        margin-left: 10px;
        border:1px solid ${COLORS.black} !important;
        /* border-radius: 0px;
        padding: 10px 34px;
        background: ${getColor("common.background")};
        border: 2px solid ${getColor("primary")} !important; */
        /* &:hover {
            background: ${getColor("common.background")};
            border: 2px solid ${getColor("text.accent")} !important;
        } */

        /* span[class^="TypographyStyle"] {
            color: ${getColor("text.main")};
            font-size: 14px;
            line-height: ${TYPOGRAPHY.lineHeight.base};
        } */
        /* &:hover {
            background: ${getColor("text.accent")};
            border: 2px solid ; 
            background: ${getColor("text.accent")};
            opacity: 0.3;
            background: none !important;

            span[class^="TypographyStyle"] {
                color: ${getColor("text.main")} ;
           
        }
        } */
        /* ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                null,
                null,
                css`
                    padding: 5px 30px;
                `,
                null,
                null,
            ])} */
    `,

};
savedOrderDetailsActionButtonsStyles.addToListButton = {
    variant: "secondary",
    css: css`
        margin-left: 10px;
        border:1px solid ${COLORS.black} !important;
    `,

};
savedOrderDetailsActionButtonsStyles.placeOrderButton = {
    variant:"primary",
    css: css`
        margin-left: 10px;
        border:1px solid ${COLORS.black} !important;
        /* border-radius: 0;
        padding: 10px 34px;
        background: ${getColor("primary")};
        border: 2px solid ${getColor("primary")};
        span[class^="TypographyStyle"] {
            ${getColor("common.background")};
            font-size: 14px;
            line-height: ${TYPOGRAPHY.lineHeight.base};
        } */
        /* &:hover {
            background: ${getColor("text.accent")};
            border: 2px solid  background: ${getColor("text.accent")};
            span[class^="TypographyStyle"] {
                ${getColor("common.background")};
            }
        } */
        /* ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                null,
                null,
                css`
                    padding: 5px 30px;
                `,
                null,
                null,
            ])} */
    `,
};
savedOrderDetailsActionButtonsStyles.twoButtonModalStyles = {
    messageText: {
        css: css`
            color: ${getColor("text.main")};
        `,
    },
    cancelButton: {
        css: css`
            border-radius: 0px;
            padding: 10px 34px;
            background: ${getColor("common.background")};
            border: 2px solid ${getColor("primary")} !important;

            span[class^="TypographyStyle"] {
                color: ${getColor("text.main")};
                font-size: 14px;
                line-height: ${TYPOGRAPHY.lineHeight.base};
            }
            &:hover {
                /* background: ${getColor("text.accent")}; */
                /* border: 2px solid  background: ${getColor("text.accent")}; */
                opacity: 0.3;
                background: none !important;

                /* span[class^="TypographyStyle"] {
                color: ${getColor("secondary")};
           
        } */
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 10px 34px;
                    `,
                    null,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    submitButton: {
        css: css`
            margin-left: 10px;
            border-radius: 0;
            padding: 10px 34px;
            background: ${getColor("primary")};
            border: 2px solid ${getColor("primary")};
            span[class^="TypographyStyle"] {
                color: ${getColor("secondary")};
                font-size: 14px;
                line-height: ${TYPOGRAPHY.lineHeight.base};
            }
            &:hover {
                background: ${getColor("text.accent")};
                border: 2px solid ${getColor("text.accent")};
                span[class^="TypographyStyle"] {
                    color: ${getColor("secondary")};
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        padding: 10px 34px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
};
savedOrderDetailsActionButtonsStyles.menuHiddenContainer = {
    above: "sm",
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    button {
                        background: none !important;
                    }
                `,
                css`
                    button {
                        background: none !important;
                    }
                `,
                css`
                    button {
                        background: none !important;
                    }
                `,
                null,
                null,
            ])}
    `,
};
savedOrderDetailsActionButtonsStyles.middleOverflowMenu = {
    cssOverrides: {
        wrapper: css`
            display: inline;
            margin-left: 20px;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        button {
                            background: none !important;
                        }
                    `,
                    css`
                        button {
                            background: none !important;
                        }
                    `,
                    css`
                        button {
                            background: none !important;
                        }
                    `,
                    null,
                    null,
                ])}
        `,
    },
};
